import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, IconButton } from "@mui/material";

interface Props {
  previewUrl: string;
  name: string;
  disabled?: boolean;
  onRemove: () => void;
}

const ArtifactAgentImageThumbnail = ({ previewUrl, name, disabled, onRemove }: Props) => (
  <Box sx={{ position: "relative", width: 56, height: 56, flexShrink: 0 }}>
    <Box
      component="img"
      src={previewUrl}
      alt={name}
      sx={{ width: "100%", height: "100%", borderRadius: 1, objectFit: "cover", border: 1, borderColor: "divider" }}
    />
    <IconButton
      aria-label={`Remove ${name}`}
      disabled={disabled}
      onClick={onRemove}
      sx={{
        position: "absolute",
        top: -8,
        right: -8,
        width: 20,
        height: 20,
        bgcolor: "background.paper",
        border: 1,
        borderColor: "divider",
        "&:hover": { bgcolor: "background.paper" },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14 }} />
    </IconButton>
  </Box>
);

export default ArtifactAgentImageThumbnail;
